// Do NOT add "use client" to this file
import { MaybeBoldProductNameWrapper } from "./MaybeBoldProductNameWrapper";

export const ProductName = ({
  productName,
  oneLineBreak,
}: {
  productName: string;
  oneLineBreak?: boolean;
}) => {
  return (
    <div className="max-w-full">
      <MaybeBoldProductNameWrapper oneLineBreak={oneLineBreak}>
        {productName}
      </MaybeBoldProductNameWrapper>
    </div>
  );
};
